import {
  isValidRetentionType,
  RetentionTypeEnum,
  type ImplantedItemCharacteristics,
} from "@jasper/client-models";
import { Stack } from "@mantine/core";
import { useTranslation } from "react-i18next";
import type { FieldValueProps } from "../../types";
import { ButtonSelect } from "../../components";
import { handleDivBlur } from "../../utils";

type Props = FieldValueProps<ImplantedItemCharacteristics>;

export const ImplantedItemCharacteristicsForm = ({
  value,
  errors = {},
  onChange,
  onBlur,
}: Props) => {
  const { t } = useTranslation("forms", {
    keyPrefix: "forms.implantedItemCharacteristics",
  });

  return (
    <Stack gap="md" onBlur={event => handleDivBlur(event, onBlur)}>
      <ButtonSelect
        data={[
          {
            value: RetentionTypeEnum.CEMENT_RETAINED,
            label: t("choices.cementRetained"),
          },
          {
            value: RetentionTypeEnum.SCREW_RETAINED,
            label: t("choices.screwRetained"),
          },
        ]}
        value={value?.retentionType}
        label={t("labels.retentionType")}
        onChange={nextRetentionType => {
          if (!nextRetentionType || !isValidRetentionType(nextRetentionType)) {
            return;
          }

          onChange({
            ...value,
            retentionType: nextRetentionType,
          });
        }}
        error={errors?.retentionType ? t("errors.retentionType") : undefined}
      />
    </Stack>
  );
};
